import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateClientMailingAddressFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};

  .MuiGrid2-root {
    padding-right: 8px;
    padding-left: 8px;
    ${responsive.MOBILE`
      padding-right: 0px;
      padding-left: 0px;
    `}
  }

  .main-container {
    width: 100%;
    padding: 0px 8px 16px;
  }
`;
